import React from 'react';

import { Listing } from 'common-ui/containers';

import { OrganizationListingHeader } from '../components';

type ListingContainerProps = {
  children: React.ReactNode;
  count: number;
};

const ListingContainer = ({ children, count }: ListingContainerProps) => {
  return (
    <>
      <OrganizationListingHeader count={count} />
      <Listing>{children}</Listing>
    </>
  );
};

export default ListingContainer;
